import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from './useTheme';
import type { ThemeMode } from './theme-context';
import {
  SegmentedControl,
  type SegmentedOption,
} from '@/components/ui/segmented-control';

const OPTIONS: SegmentedOption<ThemeMode>[] = [
  { value: 'light', label: 'Light', icon: <Sun className="size-3.5" aria-hidden /> },
  { value: 'dark', label: 'Dark', icon: <Moon className="size-3.5" aria-hidden /> },
  { value: 'system', label: 'System', icon: <Monitor className="size-3.5" aria-hidden /> },
];

interface Props {
  /** Compact = icon-only with sr-only labels; for tight headers / phone tier. */
  compact?: boolean;
}

/**
 * Three-mode theme switch (light / dark / system). Bound to the chosen `mode`
 * so 'system' stays selectable rather than collapsing to its resolved value.
 */
export function ThemeSwitch({ compact }: Props = {}) {
  const { mode, setMode } = useTheme();
  return (
    <SegmentedControl
      ariaLabel="Theme"
      value={mode}
      compact={compact}
      onValueChange={setMode}
      options={OPTIONS}
    />
  );
}
